export const BURNETT_API_ENDPOINT = "https://burnett-api.longjump.ai";
// export const BURNETT_AUTH0_DOMAIN = "dev-4z7tixat6qul8zr7.us.auth0.com";
// export const BURNETT_AUTH0_CLIENT_ID = "bhybweja1OIZLLnmisvEvfAzcaRWlzkF";
// export const BURNETT_AUTH0_DOMAIN = "longjump.us.auth0.com";
export const BURNETT_AUTH0_DOMAIN = "auth.longjump.ai";
export const BURNETT_AUTH0_CLIENT_ID = "YNb00ZRMBqPmDuIEC5chQELVBBOxzvrL";